import { CloudOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { RoomBackground } from '../Room/RoomBackground';

interface ServiceUnavailableProps {
  onRetry?: () => void;
  onGoHome?: () => void;
  retrying?: boolean;
  compact?: boolean;
}

export function ServiceUnavailable({
  onRetry,
  onGoHome,
  retrying = false,
  compact = false,
}: ServiceUnavailableProps) {
  const { t } = useTranslation();

  const content = (
    <>
      <div
        className={`mx-auto mb-4 flex items-center justify-center rounded-2xl bg-room-accent-soft ${
          compact ? 'h-14 w-14' : 'h-16 w-16'
        }`}
      >
        <CloudOff className={`text-room-accent ${compact ? 'h-7 w-7' : 'h-8 w-8'}`} strokeWidth={1.75} />
      </div>
      <h1
        className={`mb-2 font-bold text-room-text ${compact ? 'text-lg' : 'text-2xl'}`}
      >
        {t('serviceUnavailable.title')}
      </h1>
      <p className={`mb-6 text-room-text-dim ${compact ? 'text-sm' : 'text-base'}`}>
        {t('serviceUnavailable.description')}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {onRetry ? (
          <button
            type="button"
            onClick={onRetry}
            disabled={retrying}
            className="rounded-lg bg-room-accent px-4 py-2 font-medium text-[#06231D] transition-colors hover:brightness-105 disabled:opacity-50"
          >
            {retrying ? t('serviceUnavailable.retrying') : t('serviceUnavailable.tryAgain')}
          </button>
        ) : null}
        {onGoHome ? (
          <button
            type="button"
            onClick={onGoHome}
            className="rounded-lg bg-room-surface-2 px-4 py-2 text-room-text transition-colors hover:bg-room-surface-3"
          >
            {t('serviceUnavailable.goHome')}
          </button>
        ) : null}
      </div>
    </>
  );

  if (compact) {
    return (
      <div className="mx-auto mt-6 max-w-md rounded-2xl border border-room-border bg-room-surface/90 p-6 text-center backdrop-blur-sm">
        {content}
      </div>
    );
  }

  return (
    <div className="room-page min-h-screen">
      <RoomBackground />
      <div className="room-page-content flex min-h-screen items-center justify-center py-20">
        <div className="max-w-md px-4 text-center">{content}</div>
      </div>
    </div>
  );
}
